export default {

    status: {
        enable:     "启用",
        disabled:   "停用",
        freeze:     "冻结",
        notFreeze:  "非冻结",
        bet:        "可下注",
        notBet:     "不可下注",
        del:        "删除",
        success:    "成功",
        fail:       "失敗",
        checkAll:   "全选",

        loading:    "载入中",
        searching:  "查询中",
        search: {
            success: "查询成功",
            error: "查询失败",
        },
        setting: {
            success: "设定成功",
            error: "设定失败",
        },
        insert: {
            success: "新增成功",
            error: "新增失败",
        },
        update: {
            success: "更新成功",
            error: "更新失败",
            nochange: "资料无异动",
        },
        save: {
            success: "储存成功",
            error: "储存失败",
        },
        delete: {
            success: "删除成功",
            error: "删除失败"
        },
        openDraw: {
            success: "开奖成功",
            error: "开奖失败",
        },
        export: {
            error: "汇出失败"
        },
        validator: {
            error: "验证失败，请检查输入资料是否正确",
            initError: "初始资料错误",
            resDataFormatError: "接收资料格式错误"
        }
    },

    question: {
        confirm: "再次确认",
        update: "是否确定更新？",
        delete: "是否确定删除？",

        title: {
            delete: "是否确定删除{title}？",
        }
    },

    time: {
        dateCreate: "创建日期",
        dateUpdate: "更新日期",
        LastLoginDate: "最后登入时间",
        dateScope: "日期范围",
        rangeSeparator: "至",
        day: "天",
        hour: "时",
        minute: "分",
        second: "秒",
        week: {
            monday:     "星期一",
            tuesday:    "星期二",
            wednesday : "星期三",
            thursday:   "星期四",
            friday:     "星期五",
            saturday:   "星期六",
            sunday:     "星期日"
        }
    },

    button: {
        search: "查询",
        research: "重新查询",
        create: "新增",
        edit:   "编辑",
        addRow: "加入一笔",
        update: "更新",
        confirm: "确定",
        close:  "关闭",
        cancel: "取消",
        delete: "刪除",
        stepPrev: "上一步",
        stepNext: "下一步",
        export: "汇出",
        reset: "重置",
        set: "设定",
        save: "储存",
        saveSet: "储存设定",
        clear: "清除",
        remove: "移除",
        actions: "操作",


        title: {
            create: "新增{title}",
            update: "更新{title}",
        },
        dateScope: {
            latelyMinutes: "近{minute}分",
            latelyHours: "近{hour}小时",
            yesterday: "上一天",
            today: "今天",
            lastWeek: "上一週",
            thisWeek: "本週",
            lastMonth: "上月",
            thisMonth: "本月"
        }
    },

    dialog: {
        title: {
            create: "新增{title}",
            update: "更新{title}",
        }
    },

    navbar: {
        switchLang: "语言",
        home:       '首页',
        profile: '个人资讯',
        profilePassword:  '更新密码',
        logOut:     '登出',
        message: {
            hello: '{msg} 您好',
            switchLangSuccessful: "语系切换成功"
        },
        onlineCount: {
            litteryMary: "视讯小玛莉"
        }
    },

    profile: {
        identity: {
            name:       "身份",
            company:    "公司",
            companySub: "子帐号",
            agent:      "代理",
            agentSub:   "子帐号",
        },
    },

    siderbar: {
        back: "回主选单",
        filterText: "搜寻代理帐号"
    },

    validator: {
        required: "此栏为必填",
        lenStr: "长度限 {min}~{max} 字",
        minStr: "最少须填写 {min} 字以上",
        maxStr: "长度限 {min} 字以内",
        lenNum: "需介于 {min}~{max}",
        minNum: "数值须为 {min} (含)以上",
        maxNum: "数值须为 {max} (含)以下",
        type: "型态不符",
    },

    message: {
        warning: {
            dateScope: "请输入查询的日期范围起迄",
            selectDelCheckbox: "请选择要删除的资料"
        },
        exportLimit: "最多汇出{row}笔"
    },

    //共用，不分类
    fields: {
        opPass: "操作者密码",
    },

    router: {
        agent: "代理管理",
        system: "系统管理",
        dashboard: "首页",
        bulletin: "公告管理",
        game: {
            management: "游戏管理",
            gametype: "游戏大类设定",
            games: "游戏设定",
            maintain: "游戏维护"
        },
        lottery: {
            management: "彩票管理",
            type: "彩种管理",
            issue: "期数管理",
            source: "即时奖源监控",
            historySource: "数据源列表",
            risk: "玩群风险设定",
            play: "玩法赔率设定",
            draw: "彩票开奖纪录",
        },
        whitelist: "登入IP白名单",
        handicap: "限红管理",
        report: {
            title: "报表管理",
            profit: "输赢报表",
            bet: "投注纪录",
            lotterybet: "彩票投注纪录",
            gameResult: {
                title: "游戏结果",
                littleMary: "小玛莉",
                fruitevo: "超进化水果盘"
            },
            gameResultTrend : {
                title: "游戏结果(牌路)",
                littleMary: "小玛莉(牌路)",
                fruitevo: "超进化水果盘(牌路)"
            },
            profitSimple: "简易输赢报表",
            LogTransactionMember: "玩家额度纪录",
            monthly: "月报表"
        },
        currentBet: "当前投注",
        onlineMember: "在线玩家",
        authority: "权限群组管理",
        marquee: "跑马灯",
        logOperating: "操作日誌",
        profile: '个人资讯',
        profilePassword: "更新密码",
        chat: "聊天室管理",
        currency: "币别管理",
        music: "音乐管理",
        gameMusic: "游戏音乐管理"
    },

    //扩充自定义原element-ui的设定名称
    elementUI: {
        datepicker: {
            rangeSeparator: "至",
            startMonth: "开始月份",
            endMonth: "结束月份",
        }
    },

    //共用组件
    transCodeSelect: {
        fieldName: "请选择交易代码",
        bet: {
            label: "下注",
            cancel: "取消下注",
            win: "中奖",
            draw: "和局退返本金",
            withhold: "下注预扣款",
            reback: "下注写单失败，退还下注金额"
        },
        pointMember: {
            label: "存提款(会员)",
            add: "点数转入 (API)",
            minus:  "点数转出 (API)",
            manualAdd: "手动加点",
            manualMinus: "手动扣点"
        }
    },

    //共用组件-更新状态
    updateStateForm: {
        account: "帐号",
        name: "名称"
    },

    login: {
        title: '游戏管理平台',
        logIn: '登入',
        account: '帐号',
        password: '密码',
        tokenExpiredTip: '逾时登出，请重新登入'
    },

    agent: {
        name: "代理",
        code: "前缀码",
        profit: "佔成",
        handicap: "盘口(限红)",
        setHandicapDefault: "设置新建玩家默认盘口(限红)",
        manageAuthorityModule: "权限群组管理",
        moduleName: "权限",
        enable: "状态",
        freeze: "是否冻结",
        bet: "投注状态",
        operatorPassword: "操作者密码",
        report: "输赢报表",
        agentLine: "代理线",
        nextAgentSum: "下线代理总数",
        underMemberSum: "直线玩家",
        upAgent: "上级代理",
        currencyName: "币别",
        layout: "版型",
        layoutMap: {
            1: "META版",
            2: "OFA版"
        },
        placeholder: {
            account: "至少6-20英数字组合、而且须为小写字母",
            password: "至少6-20英数字或符号",
            searchAccount: "帐号搜寻"
        },
        tabs: {
            agent: "代理",
            member: "玩家",
            subAgent: "子帐号",
        },
        tagsView: {
            agent: "代理管理",
        },
        handicapList: {
            header: "盘口(限红)清单",
            title: "普通盘口(限红)",
            titleVip: "VIP盘口(限红)",
            col: {
                name: "盘口(限红)",
                betmin: "下限",
                betmax: "上限",
            }
        },
        handicapDefault: {
            tip: "请选择1-3默认普通盘口(限红)",
            tipVip: "请选择默认VIP盘口(限红)",
            col: {
                name: "盘口(限红)",
                betmin: "下限",
                betmax: "上限",
            },
            rules: {
                errorTip: "请勾选1-3项",
                errorTipVip: "请至少勾选1项",
            }
        },
        levelState: {
            title: "层级",
            company: "公司",
            generalAgent: "总代理",
            agent: "代理",
        },
        list: {
            empty: "无下层代理资料",
            nickname: "匿称",
            handicap: "盘口(限红)",
            profit: "佔成",
            status: "状态",
            freeze: "冻结",
            bet: "下注",
            remark: "备註",
        },
        step: {
            info: "基本资讯",
            handicap: "普通盘口(限红)",
            handicapVip: "VIP盘口(限红)",
            confirm: "确认",
        },
        info: {
            autoGenerate: "帐号生成方式",
            auto: "自动",
            manual: "手动",
            account: "帐号",
            nickname: "匿称",
            password: "密码",
            passwordOld: "原始密码",
            passwordCheck: "确认密码",
            passwordNew: "新密码",
            profit: "佔成",
            remark: "备註",
            module: "权限",
            moduleEmpty: "尚无权限群组资料，请先建立"
        },
        updatePassword: "更改密码",
        updatePasswordSuccess: "密码更新成功",
        updateHash: "更新Hash KEY, Hash IV",
        updateHashSuccess: "Hash KEY, Hash IV更新成功",
        rules: {
            passwordCheck: {
                diff: "两次输入密码不一致"
            },
            errorMultipleSelect: "请至少勾选一项"
        },
        formTitle: {
            create: "新增代理",
            edit: "修改代理"
        },
        question: {
            status: "确定要更改代理的帐号状态？",
            freeze: "确定要更改代理的冻结状态？",
            bet: "确定要更改代理的投注状态？",
        },
        gameEnable: {
            title: "游戏开启设定"
        },
        button: {
            gameOpen: "游戏开启",
            lotteryRiskSetting: "彩票风险设定",
            edit: "编辑资料",
            updatePassword: "更新密码",
            editOpKey: "编辑外接Key",
        },
        lottery: {
            agentRiskTitle: "代理彩票风险设定",
            agentError: "代理资料错误",
            memberRiskTitle: "会员彩票风险设定",
            memberError: "会员资料错误",
            specialRisk: "专属风控设定",
            generalRisk: "一般风控设定",
        }
    },

    subAccount: {
        title: "子帐号",
        empty: "无子帐号资料",
        subAgent: "上级代理",
        AgentAccount: "主帐号",
        account: "帐号",
        password: "密码",
        passwordCheck: "确认密码",
        passwordNew: "新密码",
        nickname: "匿称",
        status: "状态",
        moduleName: "权限",
        remark: "备註",
        lastLoginIP: "最后登录IP",
        module: "权限",
        upAgentLine: "上线",
        operatorPassword: "操作者密码",
        updatePassword: "更改密码",
        placeholder: {
            account: "至少6-20英数字组合、而且须为小写字母",
            password: "至少6-20英数字或符号",
            searchAccount: "帐号搜寻"
        },
        formTitle: {
            create: "新增子帐号",
            edit: "修改子帐号"
        },
        question: {
            status: "确定要更改子帐号的状态？",
        },
    },

    member: {
        title: "玩家",
        empty: "无玩家资料",
        AgentAccount: "代理帐号",
        account: "帐号",
        password: "密码",
        passwordCheck: "确认密码",
        passwordNew: "新密码",
        nickname: "匿称",
        handicap: "盘口(限红)",
        handicapGeneral: "普通盘口(限红)",
        handicapVip: "VIP盘口(限红)",
        points: "额度",
        BetMax: "最大限额",
        LoseMax: "最大输额",
        status: "状态",
        freeze: "冻结",
        bet: "下注",
        remark: "备註",
        operatorPassword: "操作者密码",
        placeholder: {
            account: "至少6-20英数字组合、而且须为小写字母",
            password: "至少6-20英数字或符号",
            searchAccount: "帐号搜寻"
        },
        manualAddPoint: {
            title:  "人工存提",
            button: "人工存提",
            action: "动作",
            add:    "加点",
            minus:  "扣点",
            points: "点数",
            addSuccess: "加点成功",
            minusSuccess: "扣点成功"
        },
        formTitle: {
            create: "新增玩家",
            edit: "修改玩家"
        },
        step: {
            info: "基本资讯",
            handicap: "普通盘口(限红)",
            handicapVip: "VIP盘口(限红)",
            confirm: "确认",
        },
        handicapList: {
            header: "盘口(限红)清单",
            title: "普通盘口(限红)",
            titleVip: "VIP盘口(限红)",
            col: {
                name: "盘口(限红)",
                betmin: "下限",
                betmax: "上限",
            }
        },
        info: {
            autoGenerate: "帐号生成方式",
            auto: "自动",
            manual: "手动",
            account: "帐号",
            nickname: "匿称",
            password: "密码",
            passwordCheck: "确认密码",
            passwordNew: "新密码",
            betMax: "最大限额",
            loseMax: "最大输额",
            remark: "备註"
        },
        updatePassword: "更改密码",
        updatePasswordSuccess: "密码更新成功",
        rules: {
            passwordCheck: {
                diff: "两次输入密码不一致"
            },
            errorMultipleSelect: "请至少勾选一项"
        },
        question: {
            status: "确定要更改玩家的帐号状态？",
            freeze: "确定要更改玩家的冻结状态？",
            bet: "确定要更改玩家的投注状态？",
        }
    },

    game: {
        gameTypeId: "游戏大类ID",
        gameTypeName: "游戏大类名称",
        gameId: "游戏ID",
        gameName: "游戏名称",
        enable: "启停用状态",
        updateEnableSuccess: "更新状态成功",
        sessionTimeOptions: {
            daily: "每天",
            weekly: "每週",
            monthly: "每月"
        },
        tables: {
            buttonText: "桌号",
            title: "{name} - 桌号控项设定",
            tableName: "游戏桌号名称",
            enable: "状态",
            rtpTip: "范围为88~99",
            roundTime: "整局时间(秒)",
            closeTime: "封盘秒数",
            forceTime: "封盘后强迫控制时间(秒)",
            roundLimit: "每局赔分上限",
            sessionTime: "赔分週期",
            sessionLimit: "週期赔分上限",
            reacquire: "重複取奖次数上限",
            videoURL: "视讯位址",
            rtplimitup: "RTP上限",
            rtplimitdown: "RTP下限",
            curtplimitup: "币值RTP上限",
            rules: {
                closeTimeLessThenRoundTime: "封盘秒数 必须小于 整局时间(秒)",
                roundLimitScope: "每局赔分上限需大于等于 0、而且小于 100,000,000",
                sessionLimitScope: "週期赔分上限需大于等于0、而且小于 100,000,000",
                forceTimeScope: "封盘后强迫控制时间(秒) 必须小于 封盘秒数、而且大于0",
                reacquireScope: "重复取奖次数上限需大于0"
            }
        },
        monitor: {
            buttonText: "RTP即时监控",
            title: "{name} - RTP即时监控(以台币计)"
        },
        question: {
            status: "确定要更改游戏状态？",
        },
    },

    littleMary: {
        monitor: {
            onlineCount: "线上人数",
            thisGame: "本局",
            betTotal: "本局总下注",
            betTotalDetail: "本局项目下注总额",
            nobet: "无",
            oncemore: "送灯",
            status: {
                bet: "可下注",
                control: "封盘(可控制)",
                closed: "封盘(开奖)"
            },
            weekly: {
                betTotal: "週期总下注",
                winTotal: "週期总中奖",
                winLoseTotal: "週期输赢",
                rtp: "週期RTP",
            },
            last90Days: {
                betTotal: "90天内总下注",
                winTotal: "90天内总中奖",
                winLoseTotal: "90天内输赢",
                rtp: "90天内RTP",
            },
            gameInfo: {
                description: "游戏资讯：每局{roundTime}秒、最后{closeTime}秒封盘、封盘后{forceTime}秒内可强迫开奖。 计算週期：{sessionTime}，赔分上限(每局/週期)：{roundLimit} / {sessionLimit}",
                more: "更多内容"
            },
            issueInfo: {
                roundTime: "每局时间",
                closeTime: "封盘时间",
                forceTime: "封盘后强迫控制时间",
                sessionTime: "计算週期",
                roundLimit: "每局赔分上限",
                sessionLimit: "週期赔分上限",
                reacquire: "开奖结果重取次数",
                rtp: "设定RTP",
            },
            sessionTime: {
                daily: "每天",
                weekly: "每週",
                monthly: "每月"
            },
            searchBar: {
                tableId: "桌号",
                refresh: "更新频率",
                filterAgent: "排除代理帐号",
                filterAgentTip: "按ENTER输入多笔"
            },
            button: {
                closeTable: "关闭本桌游戏",
                openTable: "开启本桌游戏",
                disableBet: "停注",
                kickOut: "踢下线",
            },
            tip: {
                tableClosing: "本桌游戏关闭中",
                forceOpen: "*强迫开奖将忽视全部限制条件，按下即时写入",
                // forceOpen2: "*按下强迫开奖即时写入",
                forceOpenOnceMore: "请填写1~3组送灯奖",
                forceOpenOnceMoreSort: "如填写送灯奖项，请依照顺序填写",
                comboRequired: "{num}颗灯为必填"
            },
            forceOpen: {
                title: "强迫开奖",
                nowRtp: "目前RTP",
                button: "强迫开奖",
                forceOpenRTP: "强迫开奖后RTP",
                forceOpenResult: "强迫开奖后输赢结果",
                symbol: "图示",
                odds: "倍数",
            },
            list: {
                memberAccount: "会员帐号",
                memberNickName: "会员暱称",
                round: "局号",
                betDetail: "下注内容",
                betCount: "注数",
                betTotal: "下注金额",
            },
            message: {
                requiredForceOpen: "请先选择强迫开奖项目与倍数",
                successForceOpen: "强迫开奖设定完成",
                disableBet: "已将会员 {account} 设为停止下注",
                kickout: "已将会员 {account} 踢下线",
                refreshChanged: "更新频率已设定为 {seconds} 秒",
                oncemoreAll: "填写送灯奖项时，请务必填写倍数",
                oncemoreSort: "请依照顺序填写送灯奖项(送灯1→送灯2→送灯3)",
                atleastonce: "请至少填写1组送灯奖、最多3组",
                issueError: "查无当期期数资料或控项资料",
                forceOpenCount: "必填填写{num}颗灯"
            },
            question: {
                closeTable: "是否确定关闭 {name} ？"
            },
            forceType: {
                single: "单颗",
                combo3: "3颗组合大奖",
                combo2: "2颗组合大奖",
            },
            showOdds: "{odds}倍"
        },
        stateOptions: {
            pending:        "未开局",
            enable:         "投注中",
            disable:        "停止下注",
            closed:         "封盘中",
            notOpen:        "未开奖",
            collected:      "已开奖",
            canceled:       "退单",
        },
        issueEnableOptions: {
            enable:  '正常',
            disable: '停止下注'
        },
        symbol: {
            "0": "送灯",
            "1": "BAR",
            "2": "77",
            "3": "星星",
            "4": "西瓜",
            "5": "铃铛",
            "6": "芒果",
            "7": "橘子",
            "8": "樱桃"
        },
        symbolCode: {
            A: "3BAR",
            B: "2BAR",
            C: "1BAR",
            D: "大7",
            E: "小7",
            F: "大星星",
            G: "小星星",
            H: "大西瓜",
            I: "小西瓜",
            J: "大铃铛",
            K: "小铃铛",
            L: "大芒果",
            M: "小芒果",
            N: "大橘子",
            O: "小橘子",
            P: "樱桃",
        }
    },

    maintain: {
        title: "游戏维护",
        typeMap: {
            interval: "时间间隔",
            daily: "每日循环",
            weekly: "每周循环",
            monthly: "每月循环"
        },
        interval: "时间",
        exceptionId: "例外帐号",
        type: "类型",
        enable: "状态",
        week: "星期",
        day: "日",
        hour: "时",
        minute: "分",
        duringTime: "持续",
        separatedByCommas: "帐号请以,隔开",
        dateStart: "开始时间",
        dateStop: "结束时间",
    },


    whitelist: {
        title: "IP白名单",
        agentAccount: "帐号",
        ip: "IP",
        type: "类型",
        enable: "状态",
        typeMap: {
            api:   "API白名单",
            agent: "代理白名单"
        },
    },

    handicap: {
        title: "盘口(限红)资料",
        type: "类型",
        type1: "普通",
        type2: "VIP",
        name: "盘口(限红)名称",
        betmin: "下限",
        betmax: "上限",
        enable: "状态",
    },

    report: {
        profit: {
            title: "输赢报表",
            tagsView: "输赢报表",
            searchTimeText: "时间范围",
            filterAgent: "排除代理帐号(按ENTER输入多笔)",
            tab: {
                agent: "代理",
                member: "玩家",
                agentEmpty: "无下层代理资料",
                memberEmpty: "无玩家投注资料",
            },
            summary: {
                subTotal: "小计",
                total: "总计"
            },
            gameTypeName: "游戏大类",
            betTotal: "投注金额",
            effectiveBet: "有效投注",
            profit: "佔成",
            refundTotal: "交上线",
            refundTotalEffective: "交上线有效投注量",
            listSubTotal: "合计",
            agent: {
                realWinnings: "代理输赢",
                total: "代理总金额",
            },
            member: {
                realWinnings: "玩家输赢",
                total: "玩家总金额",
            },
            originalCurr: "原始"  //原始幣別
        },
        profitSimple: {
            title: "简易输赢报表",
            tagsView: "简易输赢报表",
            listSubTotal: "总计",
            subAgentTitle: "下线",
            subMemberTitle: "下线玩家",
            agentTitle: "代理",
            upAgentTitle: "上线",
            agent: "代理",
            member: "玩家",
            sumRealWinnings: "代理总输赢",
            profit: "佔成",
            realWinnings: "代理输赢",
            commission: "佣金",
            total: "代理总金额",
            effectiveBet: "玩家有效投注",
            memberRealWinnings: "玩家输赢",
            memberTotal: "玩家总金额",
        },
        bet: {
            gameName: "游戏",
            tableName: "桌号",
            round: "局号",
            agents: '代理帐号(查询多名以","分隔)',
            members: '玩家帐号(查询多名以","分隔)',
            state: "状态",
            total: "总计(NTD)",
            summary: {
                betTotal: "投注总金额",
                realWinnings: "玩家总输赢",
                effectiveBet: "有效总投注",
            },
            betTotal: "投注金额",
            realWinnings: "玩家输赢",
            effectiveBet: "有效投注",
            agent: "代理",
            member: "玩家",
            betNo: "注单号",
            betDate: "投注时间",
            openDate: "开奖时间",
            openResult: "游戏结果",
            content: "下注内容",
            stateOptions: {
                notCollect: "未对奖",
                cancel: "取消单",
                lose: "未中奖",
                win: "中奖",
                draw: "和局"
            },
        },
        gameResult: {
            littleMary: {
                tableName: "桌号",
                round: "局号",
                nowTime: "查询当下时间",
                dateStart: "开始时间",
                dateClose: "封盘时间",
                dateStop: "结束时间",
                dateDraw: "开奖时间",
                openResult: "游戏结果",
                videoURL: "视讯",
                state: "状态",
                actions: "功能",
                remark: "备注",
                cancelBet: {
                    button:     "未开奖退单",
                    buttonCancel: "退单",
                    success:    "退单成功",
                    title:      "退单结果",
                    questionTitle: "退单确认",
                    question:   '此操作将取消并且退回 "{tableName}-{round}期" 之所有注单，确定执行退单？ ',
                    remarkPlaceholder: "请输入退单原因(字数限{max}字以内)",
                    account:    "帐号",
                    no:         "注单",
                    round:  "桌号/期数",
                    total:  "注单总数",
                    updateSuccess:      "退单成功笔数",
                    updPointFailureNo:  "点数退回失败笔数",
                    updEnableFailure:   "状态更新失败笔数",
                    questionBet: '此操作将取消并且退回 "{tableName}-{round}期" 之注单 {betOrderNo}，确定执行退单？ ',
                    resultCanNotModify: "注单已开奖或已取消，无需再退单",
                    resultStatusError: "退单失败，修改注单状态失败",
                    resultPointError: "退单失败，退回点数失败",
                    tipRoundError: "*局号错误",
                    tipNotOpenError: "*到期未开奖",
                    tipNotCollectError: "*已开未对奖",
                    updateSuccessCount: "本次退单数",
                    updateIsCollectedCount: "已对奖不可退单",
                    updateIsCancelCount: "已取消单",
                },
                isOpen: "是否开奖",
                isEnable: "可否下注",
                stateOptions: {
                    pending: "未开局",
                    enable: "投注中",
                    disable: "停止下注",
                    closed: "已封盘",
                    opening: "开奖中",
                    opened_collect: "对奖中",
                    collected: "已派彩"
                }
            }
        },
        logTransMember: {
            listSubTotal: "小计",
            memberList: '玩家帐号(查询多名以","分隔)',
            memberAccount: '玩家帐号',
            betOrderNo: "注单编号",
            id: "序号",
            dateTran: "操作时间",
            upAgent: "上级代理",
            upAgentLine: "上线",
            transName: "交易类型",
            beforeChangePoint: "交易前馀额",
            income: "玩家收入",
            outgo: "玩家支出",
            afterChangePoint: "交易后馀额",
            creatorAccount: "操作者",
            subTotal: "小计",
            total: "总计",
            totalIncome: "玩家总收入",
            totalOut: "玩家总支出",
            totalDiff: "玩家总收支",
            totalCount: "共 {count} 笔",
            remark: "备注"
        },
        monthly: {
            titleMonth:     "{month} 月",
            week:           "周数",
            dateRange:      "期间",
            betTotal:       "总投注",
            realWinnings:   "总输赢",
            total:          "总计",
            agent:          "总代理",
            drawerMonth:    "{month} 月  月报表",
            drawerWeek:     "{month} 月 - 第 {week} 周( {dateRange} ) 周报表"
        }
    },

    currentBet: {
        round: "局号",
        agentAccount: "代理帐号",
        memberAccount: "玩家帐号",
        agentAccountPlaceholder: '代理帐号(查询多名以","分隔)',
        memberAccountPlaceholder: '玩家帐号(查询多名以","分隔)',
        state: "状态",
        game: "游戏",
        openResult: "游戏结果",
        betTotal: "总投注",
        lastOpenResult: "近50期开奖历史",
        lastOpenResultDesc: "(由上至下、左至右)",
    },

    onlineMember: {
        agentAccount: "代理帐号",
        memberAccount: "玩家帐号",
        agentAccountPlaceholder: '代理帐号(查询多名以","分隔)',
        memberAccountPlaceholder: '玩家帐号(查询多名以","分隔)',
        onlineTotal: "在线人数",
        location: "当前位置",
        lobby: "大厅"
    },

    logOperating: {
        agentAccount:   "代理帐号",
        functionName:   "操作动作",
        postData:       "异动资料",
        state:          "状态",
        dateCreate:     "操作时间",
    },
    userAgent: {
        location:   "所在地",
        device:     "使用设备",
        browser:    "浏览器"
    },
    //for操作日誌顯示使用
    apiRouteMap: {
        API: {
            Login: {
                label:  '登入',
                description: '{Account} 登入'
            },
            Profile: {
                Info: {
                    label: '个人资讯',
                    description: ''
                },
                Logout: {
                    label: '登出',
                    description: '{Account} 登出'
                },
                UpdatePassword: {
                    label: '更新个人密码',
                    description: ''
                }
            },
            AuthorityModule: {
                Search: {
                    label:          '查询权限群组',
                    description:    '查询条件--权限群组名称：{Name}、启停用：{Enable}'
                },
                SearchTasks: {
                    label:          '查询代理之功能权限列表',
                    description:    ''
                },
                SearchModuleList: {
                    label:          '查询代理之权限群组',
                    description:    ''
                },
                Create: {
                    label:          '新增权限群组',
                    description:    '群组名称：{Name}、权限：{Authority}'
                },
                Update: {
                    label:          '更新权限群组',
                    description:    '更新权限群组编号：{Id}、权限名称：{Name}、备註：{Remark}、启停用：{Enable}、权限：{Authority}'
                }
            },
            Agent: {
                Search: {
                    label:          '查询代理资料',
                    description:    '查询代理编号：{Id}'
                },
                SearchAgents: {
                    label:          '查询下线代理资料',
                    description:    '查询代理编号 {UpAgentId} 的下线'
                },
                UpdateHandicap: {
                    label:          '设置代理的新建玩家默认盘口(限红)',
                    description:    '代理编号：{AgentId}、普通盘口：{Handicap}、VIP盘口：{VIPHandicap}'
                },
                GetAgentLineTree: {
                    label:          '查询代理线',
                    description:    ''
                },
                GetUpAgentLineTree: {
                    label:          '查询上级代理线',
                    description:    ''
                },
                Create: {
                    label:          '新增代理',
                    description:    '上层代理：{UpAgentId}、帐号：{Account}、密码：*、暱称：{NickName}、佔成：{Profit}、普通盘口：{Handicap}、VIP盘口：{VIPHandicap}、权限群组编号：{ModuleId}、备註：{Remark}'
                },
                Update: {
                    label:          '更新代理',
                    description:    '代理编号：{Id}、暱称：{NickName}、佔成：{Profit}、普通盘口：{Handicap}、VIP盘口：{VIPHandicap}、权限群组编号：{ModuleId}、备註：{Remark}'
                },
                UpdateStatus: {
                    label:          '更新代理状态',
                    description:    '代理编号：{Id}、冻结：{Freeze} (1: 冻结 / 2: 非冻结)、可否下注：{Bet} (1: 可下注 / 2: 不可下注)、状态：{Enable} (1: 启用 / 2: 停用)'
                },
                UpdatePassword: {
                    label:          '更新代理密码',
                    description:    '代理编号：{Id}'
                },
                UpdateHash: {
                    label:          '更新代理HASH KEY',
                    description:    '代理编号：{Id}'
                },
                GameEnableList: {
                    label:          '查询代理已启用的游戏列表',
                    description:    ''
                },
                UpGameEnableList: {
                    label:          '设定代理游戏',
                    description:    '代理编号：{AgentId}、游戏类别：{GameTypeId}、列表：{List}'
                },
            },
            Member: {
                Search: {
                    label:          '查询玩家资料',
                    description:    '代理编号：{AgentId}、玩家帐号：{Account}'
                },
                Create: {
                    label:          '新增玩家',
                    description:    '代理编号：{AgentId}、帐号：{Account}、密码：*、暱称：{NickName}、最大限额：{BetMax}、最大输额：{LoseMax}、普通盘口：{Handicap}、VIP盘口：{VIPHandicap}、备註：{Remark}'
                },
                Update: {
                    label:          '更新玩家资料',
                    description:    '玩家编号：{Id}、暱称：{NickName}、最大限额：{BetMax}、最大输额：{LoseMax}、普通盘口：{Handicap}、VIP盘口：{VIPHandicap}、备註：{Remark}'
                },
                UpdateStatus: {
                    label:          '更新玩家状态',
                    description:    '玩家编号：{Id}、冻结：{Freeze} (1: 冻结 / 2: 非冻结)、可否下注：{Bet} (1: 可下注 / 2: 不可下注)、状态：{Enable} (1: 启用 / 2: 停用)'
                },
                UpdatePassword: {
                    label:          '更新玩家密码',
                    description:    ''
                },
                UpdateMemberBet: {
                    label:          '更新玩家下注状态 ',
                    description:    '玩家编号：{Id}、可否下注：{Bet} (1: 可下注 / 2: 不可下注)'
                },
                ManualAddPoint: {
                    label:          '玩家额度-人工存提',
                    description:    '玩家帐号：{Account}、交易群组代码：{Group}、交易项目代码：{Item}、点数:{Points}'
                },
                SearchOnline: {
                    label:          '在线玩家列表',
                    description:    '查询代理帐号列表：{AgentList}、查询玩家帐号列表：{MemberList}'
                },
                KickOut: {
                    label:          '在线玩家踢下线',
                    description:    '玩家编号：{MemberId}'
                },
            },
            SubAccount: {
                Search: {
                    label:          '查询子帐号资料',
                    description:    '代理编号：{AgentId}、子帐号：{Account}'
                },
                Create: {
                    label:          '新增子帐号',
                    description:    '上层代理：{AgentId}、帐号：{Account}、密码：*、暱称：{NickName}、权限群组编号：{ModuleId}、备註：{Remark}'
                },
                Update: {
                    label:          '更新子帐号资料',
                    description:    '子帐号编号：{Id}、暱称：{NickName}、权限群组编号：{ModuleId}、备註：{Remark}、状态：{Enable} (1: 启用 / 2: 停用)'
                },
                UpdateStatus: {
                    label:          '更新子帐号状态',
                    description:    '子帐号编号：{Id}、状态：{Enable} (1: 启用 / 2: 停用)'
                },
                UpdatePassword: {
                    label:          '更新子帐号密码',
                    description:    ''
                },
            },
            GameType: {
                Search: {
                    label:          "查询游戏类别",
                    description:    ''
                },
                List: {
                    label:          "游戏类别列表",
                    description:    ''
                },
            },
            Games: {
                Search: {
                    label:          "查询游戏",
                    description:    '查询游戏类别：{GameTypeId}'
                },
                List: {
                    label:          "查询游戏列表",
                    description:    ''
                },
                TableSearch: {
                    label:          "查询游戏桌号",
                    description:    '查询游戏：{GameId}'
                },
                TableList: {
                    label:          "查询游戏列表",
                    description:    ''
                },
                UpdateGameSetting: {
                    label:          "更新游戏控项",
                    description:    '流水号：{Id}、游戏类别编号：{GameTypeId}、游戏编号：{GameId}、桌号：{TableId}、桌号名称：{TableName}、状态：{Enable} (1: 启用 / 2: 停用)、控项内容：{Controller}'
                },
                UpdateGameStatus: {
                    label:          "更新游戏状态",
                    description:    '流水号：{Id}、状态：{Enable} (1: 启用 / 2: 停用)'
                },
                UpdateGameTableStatus: {
                    label:          "更新游戏桌号状态",
                    description:    '流水号：{Id}、状态：{Enable} (1: 启用 / 2: 停用)'
                },
                RTPInfo: {
                    label:          "查询游戏桌号RTP资讯",
                    description:    ''
                },
            },
            Maintain: {
                Search: {
                    label:          '查询游戏维护',
                    description:    '游戏类别：{GameTypeId}、游戏编号：{GameId}、状态：{Enable} (1: 启用 / 2: 停用)'
                },
                Create: {
                    label:          '新增游戏维护',
                    description:    '游戏类别：{GameTypeId}、游戏编号：{GameId}、维护类型：{Type} (1: 时间区间 / 2: 每日循环 / 3: 每周循环 / 4: 每月循环)、状态：{Enable} (1: 启用 / 2: 停用)、例外帐号：{ExceptionId}、时间循环：{Interval}、时间循环：{Interval2}'
                },
                Update: {
                    label:          '更新游戏维护',
                    description:    '流水号：{Id}、游戏类别：{GameTypeId}、游戏编号：{GameId}、维护类型：{Type} (1: 时间区间 / 2: 每日循环 / 3: 每周循环 / 4: 每月循环)、状态：{Enable} (1: 启用 / 2: 停用)、例外帐号：{ExceptionId}、时间循环：{Interval}、时间循环：{Interval2}'
                },
            },
            AgentWhiteList: {
                Search: {
                    label:          "查询白名单",
                    description:    '代理帐号：{AgentAccount}、类别：{Type} (1: API / 2: 代理)、IP：{IP}、状态：{Enable} (1: 启用 / 2: 停用)'
                },
                SearchAvailable: {
                    label:          "已启用的白名单",
                    description:    ''
                },
                Create: {
                    label:          "新增白名单",
                    description:    '代理帐号：{AgentAccount}、类别：{Type} (1: API / 2: 代理)、IP：{IP}'
                },
                Update: {
                    label:          "更新白名单",
                    description:    '流水号：{Id}、代理帐号：{AgentAccount}、IP：{IP}'
                },
                Delete: {
                    label:          "删除白名单",
                    description:    '流水号：{Id}'
                },
            },
            Handicap: {
                Search:{
                    label:          "查询盘口(限红)",
                    description:    '类别：{Type} (1: 一般 / 2: VIP)、盘口名称：{Name}、状态：{Enable} (1: 启用 / 2: 停用)'
                },
                List: {
                    label:          "已启用盘口(限红)",
                    description:    ''
                },
                Create: {
                    label:          "新增盘口(限红)",
                    description:    '类别：{Type} (1: 一般 / 2: VIP)、盘口名称：{Name}、最小下注：{BetMin}、最大下注：{BetMax}'
                },
                Update: {
                    label:          "更新盘口(限红)",
                    description:    '流水号：{Id}、类别：{Type} (1: 一般 / 2: VIP)、盘口名称：{Name}、最小下注：{BetMin}、最大下注：{BetMax}、状态：{Enable} (1: 启用 / 2: 停用)'
                },
                UpdateStatus: {
                    label:          "更新盘口(限红)状态",
                    description:    '流水号：{Id}、状态：{Enable} (1: 启用 / 2: 停用)'
                },
            },
            Report: {
                Profit: {
                    Search: {
                        label:          "查询输赢报表",
                        description:    '代理编号：{AgentId}、开始时间：{StartTime}、结束时间：{EndTime}'
                    },
                    Agent: {
                        label:          "查询输赢报表(代理列表)",
                        description:    '代理编号：{AgentId}、开始时间：{StartTime}、结束时间：{EndTime}'
                    },
                    Member: {
                        label:          "查询输赢报表(玩家列表)",
                        description:    '代理编号：{AgentId}、开始时间：{StartTime}、结束时间：{EndTime}'
                    },
                },
                ProfitSimple: {
                    Search: {
                        label:          "查询简易输赢报表",
                        description:    '代理编号：{AgentId}、开始时间：{StartTime}、结束时间：{EndTime}'
                    },
                }
            },
            BetOrder: {
                Search: {
                    label:          "查询投注纪录",
                    description:    '开始时间：{StartTime}、结束时间：{EndTime}、游戏编号：{GameId}、局号：{Round}、代理列表：{AgentList}、玩家列表：{MemberList}、已对奖：{Collect}、取消注单：{Cancel} (0: 非取消单 / 1: 客户取消单 / 2: 系统取消单 / 3:追单中奖取消)、中奖状态：{State} (0:没中奖, 1:中奖, 2:和局)'
                },
                SearchByRound: {
                    label:          "查询游戏单局的投注纪录",
                    description:    ''
                },
                SearchSummary: {
                    label:          "查询游戏单局的统计值",
                    description:    ''
                },
                SearchCurrent: {
                    label:          "当前投注",
                    description:    '局号：{Round}、开始时间：{StartTime}、结束时间：{EndTime}'
                },
            },
            GameResult: {
                LittleMary: {
                    Search: {
                        label:          "查询小玛莉游戏结果",
                        description:    '开始时间：{StartTime}、结束时间：{EndTime}、局号：{Round}、桌号：{TableId}'
                    },
                    TrendSearch: {
                        label:          "查询小玛莉游戏结果(牌路)",
                        description:    '开始时间：{StartTime}、结束时间：{EndTime}、局号：{Round}、桌号：{TableId}'
                    },
                    ForceOpen: {
                        label:          "小玛莉强迫开奖",
                        description:    '游戏编号：{GameId}、桌号：{TableId}、局号：{Round}、图示：{KeyId}、倍数：{Odds}'
                    },
                    ForceOpenResult: {
                        label:          "小玛莉强迫开奖后的结果",
                        description:    '查询条件--游戏编号：{GameId}、桌号：{TableId}、局号：{Round}、图示：{KeyId}、倍数：{Odds}'
                    },
                    CancelTimeoutOrders: {
                        label:          "小玛莉未开奖取消注单",
                        description:    '游戏编号：{GameId}、桌号：{TableId}、局号：{Round}、备註：{Remark}'
                    },
                }
            },
            Log: {
                TransactionMember: {
                    label:          "查询玩家交易额度纪录",
                    description:    '查询条件--开始时间：{StartTime}、结束时间：{EndTime}、玩家列表：{MemberList}、注单编号：{BetOrderNo}、IP：{IP}、交易群组代码：{Group}、交易项目代码：{Item}'
                },
                AgentOperating: {
                    label:          "查询操作日誌",
                    description:    '查询条件--开始时间：{StartTime}、结束时间：{EndTime}、代理列表：{AgentList}'
                },
            },
            Bulletin: {
                Search: {
                    label:          '查询公告',
                    description:    ''
                },
                Create: {
                    label:          '新增公告',
                    description:    '游戏编号：{GameId}、公告重要性：{Important} (1: 一般公告 / 2: 紧急公告)、公告推播：{Push} (0: 无 / 1: 推播)、公告标题：{Title}、公告内容：{Content}、开始时间：{StartTime}、结束时间：{EndTime}、备註：{Remark}、状态：{Enable} (1: 启用 / 2: 停用)'
                },
                Update: {
                    label:          '更新公告',
                    description:    '流水号：{Id}、游戏编号：{GameId}、公告重要性：{Important} (1: 一般公告 / 2: 紧急公告)、公告推播：{Push} (0: 无 / 1: 推播)、公告标题：{Title}、公告内容：{Content}、开始时间：{StartTime}、结束时间：{EndTime}、备註：{Remark}、状态：{Enable} (1: 启用 / 2: 停用)'
                },
            },
            Marquees: {
                Search: {
                    label:          '查询跑码灯',
                    description:    ''
                },
                Create: {
                    label:          '新增跑码灯',
                    description:    '游戏编号：{GameId}、跑马灯内容：{Content}、开始时间：{StartTime}、结束时间：{EndTime}、备註：{Remark}、状态：{Enable} (1: 启用 / 2: 停用)'
                },
                Update: {
                    label:          '更新跑码灯',
                    description:    '流水号：{Id}、游戏编号：{GameId}、跑马灯内容：{Content}、开始时间：{StartTime}、结束时间：{EndTime}、备註：{Remark}、状态：{Enable} (1: 启用 / 2: 停用)'
                },
            },
            Config: {
                Search: {
                    label:          '基本设定',
                    description:    ''
                },
            },
        },
    },

    authority: {
        title: "权限群组",
        name: "权限群组名称",
        usedCount: "使用人数",
        enable: "启停用",
        remark: "备註",
        authority: "权限功能",
        agentAccount: "代理帐号",
        task: "功能说明",
        privilegeOptions: {
            none: "无",
            all: "最大权限",
            read: "只可查询"
        },
        placeholder: {
            select: "全部权限"
        },
        tabs: {
            first: "权限列表",
            second: "使用者列表"
        },
        type: "类型"
    },
    bulletin: {
        "name": "公告管理",
        "id" : "编号",
        "title" : "标题",
        "content" : "公告内容",
        "gameType" : "游戏大类",
        "game" : "游戏",
        "enable" : "状态",
        "bulletinTime" : "公告时间",
        "dateCreate" : "建立时间",
        "important" : "公告重要性",
        "normal" : "一般公告",
        "urgent" : "紧急公告",
        "remark" : "备註",
        "push" : "公告推播",
        "no": "无",
        "yes": "推播",
        oneatleast: "请至少输入一笔",
        titleRequired: "请填写 {lang} 的标题",
        contentRequired: "请填写 {lang} 的公告内容"
    },

    marquee: {
        "name": "跑马灯管理",
        "id" : "编号",
        "content" : "跑马灯内容",
        "gameType" : "游戏大类",
        "game" : "游戏",
        "enable" : "状态",
        "marqueeTime" : "跑马灯时间",
        "dateCreate" : "建立时间",
        "important" : "跑马灯重要性",
        "normal" : "一般跑马灯",
        "urgent" : "紧急跑马灯",
        "remark" : "备註",
        "push" : "跑马灯推播",
        "no": "无",
        "yes": "推播"
    },

    apiErrorCode: {
        1001: "参数错误",
        1002: "内部错误(sql)",
        1003: "内部错误(redis)",
        1004: "新增失败(sql)",
        1005: "新增失败(redis)",
        1006: "更新失败(sql)",
        1007: "更新失败(redis)",
        1008: "",

        1020: "图片大小超过限制",

        1101: "IP格式错误",

        7004: "HashKey or HashIv 错误",

        2001: "登入失败(帐号或密码错误、已停用、无登入权限)",
        2002: "Token错误或已失效",
        2003: "帐号已存在",
        2004: "查无上层代理线",
        2005: "新增代理资料失败(insert语法有误)",
        2006: "新增代理线资料失败(insert语法有误)",
        2007: "自动生成代理代码错误",
        2008: "查无上层代理资料",
        2009: "查无代理资料",
        2010: "权限不足(Forbidden)",
        2011: "设定未完成",
        2012: "帐号不属于操作者直属下线",
        2013: "无此笔资料操作权限",
        2014: "权限群组编号不属该代理",
        2015: "操作者密码错误",
        2016: "非总代理，不可更新币别",
        2017: "非总代理",

        2031: "查无子帐号资料",
        2032: "子帐号不属于登入者代理所属",

        2051: "查无权限群组资料",
        2052: "尚无设定权限",
        2053: "权限已被使用，无法修改",

        2101: "游戏token错误",
        2102: "server token错误",
        2103: "找不到登入资料",
        2104: "找不到会员 (帐号不存在)",
        2105: "帐号已存在",
        2106: "帐号已冻结",
        2107: "帐号无法下注",
        2108: "帐号已停用",
        2109: "帐号不存在于操作者代理线",
        2110: "点数异动代号错误",
        2111: "手动加扣点失败",
        2113: "资料已经存在",
        2114: "会员馀额不足",
        2115: "会员馀额更新失败",
        2116: "新增会员资料失败(insert错误)",
        2117: "更新会员资料失败",
        2118: "更新会员资料失败",

        2201: "跑马灯新增失败",
        2202: "跑马灯更新失败",
        2203: "跑马灯排序失败",

        2211: "公告新增失败",
        2212: "公告更新失败",

        2221: "轮播图新增失败",
        2222: "轮播图更新失败",

        2231: "盘口名称已存在",
        2232: "代理盘口不存在",
        2233: "会员盘口不存在",

        3001: "找不到游戏",

        3101: "游戏控项型态错误",
        3102: "游戏控项设定错误",
        3103: "下注项目错误",
        3104: "局号错误",
        3105: "该局已关盘",
        3106: "至少有一个下注项目",
        3107: "下注失败",
        3108: "限红错误",
        3109: "注单不存在",
        3110: "非当前局号",
        3115: "更新失败(已封盘)",
        3116: "更新失败(已结束)",

        3120: "取消注单失败",

        3201: "游戏大类已存在",
        3202: "游戏大类不存在",
        3203: "游戏已存在",
        3204: "游戏不存在",
        3205: "游戏桌已存在",
        3206: "游戏桌不存在",
        3207: "游戏大类已停用",
        3208: "游戏已停用",
        3209: "游戏桌已停用",
        3210: "游戏维护中",

        4001: "查无彩种资料",
        4002: "查无期数资料",
        4003: "无法手动开奖(可能已开奖或已删单)",
        4004: "无法手动开奖(未结束)",
        4005: "手动开奖结果验证错误，请检查游戏开奖规则",
        4006: "本期资料已无法修改",
    },
    musicApiErrorCode: {
        1001: "带入参数错误",
        1002: "音乐资料写入DB失败",
        1003: "音乐资料更新DB失败",
        1004: "取得资料失败",
        1005: "游戏音乐资料写入DB失败",
        100: "寻找ffmpeg程式失败",
        101: "Youtube网址匹配失败",
        102: "找不到影片",
        103: "取得影片详细资料失败",
        104: "建立档案失败",
        105: "档案复制失败",
        106: "linux系统转档失败",
        107: "windows系统转档失败",
        108: "抓不到OS系统可用程式",
        109: "linux系统删除档案失败",
        110: "windows系统删除档案失败",
        111: "复制MP3时，开启档案失败",
        112: "复制MP3时，建立档案失败",
        113: "复制MP3时，复制档案失败",
        114: "音乐秒数超过限制",
        115: "音量调整失败",
        116: "语系缺少参数",
        117: "查无此音乐",
        118: "volume值过大",
        119: "查无桌号资料",
        120: "请输入要设定的游戏",
        121: "请输入GameTypeId",
        122: "此音乐已停用",
        123: "状态未变动",
        124: "游戏音乐重复加入"
    },

    formula: {
        betTotal:               "(未取消单的)总投注金额",            //投注总金额
        effectiveBetTotal:      "投注总金额 - (双面对押 + 未开奖)",  //有效总投注
        effectiveBet:           "投注金额 - (双面对押 + 未开奖)",    //有效投注
        playerRealWinnings:     "总投注金额 - 总中奖金额",           //玩家输赢
        agentRealWinnings:      "(总投注金额 - 总中奖金额) × -1",    //代理输赢
        realWinningsPercents:   "(输赢 / 有效投注 ) × 100",         //% = (输赢 / 有效投注 ) × 100
        total:                  "输赢 - 优惠活动",                  //总金额
        refundTotalPercents:    "(100% - 代理占成%) / 100",         //交上线百分比
        refundTotal:            "交上线% × 总金额",                 //交上线
        refundTotalEffective:   "交上线% × 有效投注量",             //交上线有效投注量
        empty:                  "尚无提示"
    },
    chat: {
        editConfig:     "编辑聊天室设定档",
        deleteMessage:  "删除讯息",
        deleteMessageAll:  "删除全部讯息",
        cancelDelete:   "取消删除",
        messagePlaceholder: "请输入内容开始聊天(限{chatMessageLimit}字)",
        sendMessage:    "发送讯息",
        filterPlaceholder: "输入后按Enter可新增多笔过滤词",
        questionDelete: "确定要删除已选择的讯息?",
        questionAllDelete: "确定要删除全部讯息?",
        filterWords:    "聊天室过滤词语",
        messageLimit:   "聊天室讯息保留笔数",
        messageMax:     "聊天室每则讯息长度限制",
        clearEveryday:  "聊天室是否每日定时清除",
        message: {
            isConn:         "聊天室连线中",
            isReading:      "读取聊天室资讯",
            openConfigError: "查询设定档错误",
            errorConn:      "无连线至聊天室",
            selectRoom:     "请选择聊天室，开始传讯息",
            empty:          "尚无聊天讯息"
        }
    },
    currency: {
        title: "币别",
        id: "币别编号",
        code: "币别代码",
        name: "币别名称",
        rate: "汇率",
        enable: "状态"
    },
    music: {
        title: "音乐",
        musicName: "歌曲显示名称",
        enable: "启停用",
        button: {
            create:         "新增音乐",
            edit:           "编辑音乐",
            editdB:         "调整音量",
            add:            "加入音乐",
            gameAddMusic:   "游戏加入音乐",
            gameUsed:       "使用中游戏列表",
            musicUsed:      "使用中音乐清单",
        },
        id: "编号",
        index: "序",
        youtubeUrl: "youtube网址",
        volume: "音量大小",
        lang: "适用语系",
        tryToPlay: "音乐试听",
        remark: "备注",
        gameSelect: "游戏选择",
        gameTypeName: "游戏大类",
        gameName: "游戏",
        tableName: "桌号",
        actions: "功能",
        newAdd: "新加入",
        searchMusicNamePlaceholder: "输入歌曲显示名称搜寻",
        volumePlaceholder: "预设89dB",
        langPlaceholder: "请选择适用语系",
        message: {
            musicExists: "音乐已存在清单",
            addMusicSuccess: "音乐已成功加入清单",
            removeNewMusic: "只可移除新加入音乐",
            emptyNewMusic: "无新加入音乐",
            musicNameTip: "请至少输入一种语言的歌曲名称",
            musicNameTip2: "储存时，如为空值的语言，将自动补上第一笔有填写的歌曲名称",
            addGameTipTitle: "加入提示",
            addGameTip1: "请选择「游戏大类、游戏」再做加入。 ",
            addGameTip2: '如已设定游戏，则无法再设定桌，例如：已设定音乐加入"视讯/小玛莉"，则无需再加入"视讯/小玛莉/水果派对"。 ',
            addGameTip3: '如已设定桌，则无法再设定游戏，如要设定必须先删除桌的资料，再设定游戏，例如：已设定音乐加入"视讯/小玛莉/水果派对"，则无法再加入"视讯/小玛莉"，如要加入，请先删除"视讯/小玛莉/水果派对"后，即可做加入。 ',
            deleteMusicTip: '"{game}"的音乐"{music}"'
        },
        validator: {
            youtubeUrl: "此栏为必填，而且需为https://开头",
            musicName: "请至少输入一种语言的歌曲名称",
            gameRequired: "请先选择游戏大类、游戏",
            addGameRowError: "加入失败，请勿重复设定资料"
        }
    },
    lottery: {
        lotteryTypeGroup:       "彩群编号",
        lotteryTypeGroupName:   "彩群名称",
        lotteryType:            "彩种编号",
        lotteryTypeName:        "彩种名称",
        lotteryPlayGroup:       "玩群编号",
        lotteryPlayGroupName:   "玩群名称",
        lotteryPlay:            "玩法编号",
        lotteryPlayName:        "玩法名称",
        lotteryContent:         "项目编号",
        lotteryContentName:     "项目名称",
        lotteryMod:             "分类",
        lotteryTypTitle:        "彩种",
        lastBetTime:            "开奖前最后下注时间(秒)",
        cycle:                  "期数编码规则",
        info:                   "彩票玩法规则",
        seq_start:              "年度流水起始编号",
        openFreq:               "开奖频率",
        drawTimeOut:            "开奖逾时秒数",
        index:                  "序",
        enable:                 "状态",
        issue:                  "期数",
        betEnable:              "可否下注",
        openResult:             "开奖结果",
        openResult2:            "第二组开奖结果",
        dateStart:              "开盘时间",
        dateClose:              "封盘时间",
        dateStop:               "结束时间",
        dateCurrent:            "所属日期",
        dateDraw:               "开奖时间",
        drawManual:             "开奖模式",
        dateDrawSource:         "奖源开奖时间",
        drawCollect:            "已对奖",
        drawCancel:             "删单",
        drawOpenStatus:         "开奖状态",
        drawSourceStatus:       "奖源状态",
        remark:                 "备注",
        manualOpenDraw:         "手动开奖",
        btnOpenDraw:            "进行开奖",
        btnDeleteSpecRisk:      "删除专属风控设定",
        odds:                   "赔率",
        modOption: {
            highFreq:   "高频彩",
            lowFreq:    "低频彩",
            official:   "官方彩",
            selfOpen:   "自开彩"
        },
        lottType: {
            message: {
                issueRule: "期数编号从 {start} ~ {end}、每{freqSec}秒开1期、起始时间: {startat}",
                rule1: "开奖号码：{NumMin} ~ {NumMax}",
                rule2: "每期开出 {NumCount} 个号码",
                rule3: "开奖号码不可重复",
                rule4: "每一位位置的开奖号码可以重复",
                rule5: "每天共{IssueSum}期",
                rule6: "期数编码规则「年月日(各2码)+流水号({IssueSeq}码)」",
            }
        },
        option: {
            enable:     "可下注",
            disable:    "停止下注",
            auto:       "自动",
            manual:     "手动",
            normal:     "正常单",
            cancel:     "删单",
            collect:    "已对奖",
            notCollect: "未对奖",
        },
        validator: {
            dateStartMustGreaterThenDateClose: "封盘时间必须大于开盘时间",
            dateCloseMustLessThenDateStop: "封盘时间不可超过本期开奖时间",
            errorLotteryType: "查无彩种"
        },
        issueDraw: {
            editIssueTimeTitle: "修改期数时间",
            updateSuccess:      "期数时间更新成功",
            betTotal:           "投注额(注数/总金额)",
            firstOpenSource:    "最早开奖源",
            sourceName:         "数据源",
            sourceList:         "奖源列表",
            issueClass:         "期别",
            lastIssue:          "前期",
            currentIssue:       "本期",
            drawSource:         "历史数据",
            status: {
                1: "正常",
                2: "手动开奖",
                3: "提早开奖"
            }
        },
        sourceNameMap: {
            "3": "招财猫"
        },
        playGroup: {
            selectType: "选择彩种",
            message: {
                selectTip1: "以第一个勾选的彩种，带出其设定值",
                selectTip2: "更新时，会更新设定值到已勾选的彩种",
                required: "所有栏位均为必填，只可输入数字 (单注最小投注额，可输入数字或小数点)",
                betMinLimitCompareBetMaxLimit:  "单注最小投注额 不可超过 单注最大下注",
                betMinLimitCompareCompany:      "代理的「单注最小投注额」不可低于公司设定值",
                betMaxLimitCompareCompany:      "代理的「单注最大投注额」不可高于公司设定值",
                betWinningLimitCompareCompany:  "代理的「单注奖金上限」不可高于公司设定值",
                betCountLimitCompareCompany:    "代理的「单期注数上限」不可高于公司设定值",
                issueLimitCompareCompany:       "代理的「单期下注上限」不可高于公司设定值",
                winningLimitCompareCompany:     "代理的「单期奖金上限」不可高于公司设定值",
                getDefaultAgentError:           "代理预设值资料查询错误",
                getDefaultAgentRowsError:       "代理预设值资料笔数错误",
                betMinLimitCompareDefaultAgent:      "「单注最小投注额」不可低于代理预设值",
                betMaxLimitCompareDefaultAgent:      "「单注最大投注额」不可高于代理预设值",
                betWinningLimitCompareDefaultAgent:  "「单注奖金上限」不可高于代理预设值",
                betCountLimitCompareDefaultAgent:    "「单期注数上限」不可高于代理预设值",
                issueLimitCompareDefaultAgent:       "「单期下注上限」不可高于代理预设值",
                winningLimitCompareDefaultAgent:     "「单期奖金上限」不可高于代理预设值",
            },
            name:           "玩法设定",
            singleSetting:  '单注设定',
            issueSetting:   '单期设定',
            betMinLimit:    "单注最小投注额",
            betMaxLimit:    "单注最大投注额",
            betWinningLimit: "单注奖金上限",
            betCountLimit:  "单期注数上限",
            issueLimit:     "单期下注上限",
            winningLimit:   "单期奖金上限",
            defaultAgentRisk:   "代理预设值",
            companyRisk:        "公司设定值",

        },
        pk10: {
            resultRank: "第{index}名",
            play: {
                champion:       "冠军",
                secondPlace:    "亚军",
                thirdPlace:     "第三名",
                fourthPlace:    "第四名",
                fifthPlace:     "第五名",
                sixthPlace:     "第六名",
                seventhPlace:   "第七名",
                eightPlace:     "第八名",
                ninthhPlace:    "第九名",
                tenthPlace:     "第十名",
            },
            message: {
                range: "请完整填写开奖结果，必须为数字、并且号码在 {NumMin} ~ ${NumMax} 之间",
                noRepeat: "奖号不可重复",
                confirm: "彩种： {LotteryTypeName}<br>期数： {Issue}<br>奖号： {OpenResult}<br>开奖时立即对奖，请再次确认奖号是否正确？"
            }
        },
        shishi: {
            resultBall1: "万",
            resultBall2: "千",
            resultBall3: "百",
            resultBall4: "十",
            resultBall5: "个",
        },
        bullseye: {
            resultBall: "奖号{index}"
        },
        cancelBet: {
            confirmBetNo: '此操作将取消并且退回"{issue}期"之注单号{betOrderNo}，确定执行退单？ ',
            confirmAll:   '此操作将取消并且退回{LotteryTypeName}第{Issue}期之所有注单，确定执行退单？ ',
            issue:  "彩种/期数",
        },
        betContentMap: {
            number: "号码",
            rank: "名次",
            unlocated: "不定位",
            big: "大",
            small: "小",
            single: "单",
            double: "双",
            prime: "质",
            combined: "合",
            dragon: "龙",
            tiger: "虎",
            leopard: "豹子",
            straight: "顺子",
            pair: "对子",
            semiShun: "半顺",
            miscellaneous: "杂六",
            notSelected: "自选不中",
            rankNum: "个名次",
            sumOftwo: "冠亚和值",
            combinationOftwo: "冠亚组合",
            positioning: "名次定位",
            rankDouble: "名次双面",
            directElection: "前三名直选",
            baccarat: "百家乐",
            player: "闲",
            banker: "庄",
            tie: "和",
            fiveStar: "五星",
            fourStar: "四星",
            threeStar: "三星",
            twoStar: "二星",
            oneStar: "一星",
            threeBefore: "前三码",
            threeCenter: "中三码",
            threeAfter: "后三码",
            duplexSelectionDirectly: "直选复式",
            singleSelectionDirectly: "直选单式",
            groupSelection: "组选",
            singleNumber: "单号",
            doubleNumber: "二重号",
            threeNumber: "三重号",
            fourNumber: "四重号",
            groupOfThreeDuplexes: "组三复式",
            groupOfThree: "组选三",
            groupOfThreeSingle: "组三单式",
            groupOfSixDuplexes: "组六复式",
            groupOfSixSingle: "组六单式",
            twoBefore: "前二码",
            twoAfter: "后二码",
            groupOfTwoDuplexes: "组二复式",
            groupOfTwoSingle: "组二单式",
            oneStarLocated: "一星定位",
            singleWay: "单式",
            notPositioned: "不定位",
            threeBeforeGetOne: "前三一码",
            threeCenterGetOne: "中三一码",
            threeAfterGetOne:  "后三一码",
            threeBeforeGetTwo: "前三二码",
            threeCenterGetTwo: "中三二码",
            threeAfterGetTwo:  "后三二码",
            fourAfterGetOne:   "后四一码",
            fourAfterGetTwo:   "后四二码",
            fiveStarGetTwo:    "五星二码",
            fiveStarGetThree:  "五星三码",
            doubleSided: "双面",
            stray: "串关",
            doubleSidedStray: "双面串关",
            twoStray: "两星串关",
            threeStray: "三星串关",
            fourStray: "四星串关",
            fiveStray: "五星串关",
            fiveSum: "五球总和",
            showHand: "梭哈",
            fullHouse: "葫芦",
            fiveOfAKind: "五条",
            fourOfAKind: "四条",
            threeOfAKind: "三条",
            twoPair: "两对",
            onePair: "一对",
            scatter: "散号",
            bullfighting: "斗牛",
            bull: "牛",
            bullTwo: "牛牛",
            bullBig: "牛大",
            bullSmall: "牛小",
            bullSingle: "牛单",
            bullDouble: "牛双",
            nobull: "无牛",
            threeSum: "三球总和",
            firstThreeSum: "前三总和",
            middleThreeSum: "中三总和",
            lastThreeSum: "后三总和",
            selectionNumber: "选号",
            direction: "方位",
            upMiddleDown: "上中下盘",
            up: "上",
            middle: "中",
            down: "下",
            oddTieEven: "奇和偶盘",
            odd: "奇",
            even: "偶",
            sum: "总数",
            bigSingle: "大单",
            smallSingle: "小单",
            bigDouble:  "大双",
            smallDouble: "大双",
            fiveElements: "五元素",
            gold:  "金",
            wood:  "木",
            water: "水",
            fire:  "火",
            earth: "土",
            index: "指数",
            posNegLimits: "正负极限",
            perPoint: "每点金额"
        }
    },
    languageMap: {
        "zh-tw":    "繁体中文",
        "zh-cn":    "简体中文",
        "en":       "英语",
        "pt":       "葡萄牙语",
        "vi":       "越南语"
    },
    //DB key-name 对应表
    db: {
        gameType: {
            "1": "视讯",
            "2": "电子",
            "3": "真人",
            "4": "彩票",
            "5": "体育",
        },
        game: {
            "1": {
                "1": "小玛莉",
                "2": "超进化水果盘"
            }
        },
        gameTable: {
            "1": {
                "1": {
                    "1": "水果派对",
                    "2": "欢乐熊猫",
                    "3": "小玛莉"
                },
                "2": {
                    "1": "玛力欧",
                    "2": "快打旋风",
                    "3": "炸弹超人"
                }
            }
        },
        task: {
            agent:      "代理管理",
            gameType:   "游戏大类设定",
            games:      "游戏设定",
            maintain:   "游戏维护",
            whitelist:  "登入IP白名单",
            handicap:   "限红管理",
            "report-profit":                "输赢报表",
            "report-profitSimple":          "简易输赢报表",
            "report-bet":                   "投注纪录",
            "report-gameResult":            "游戏结果",
            "report-gameResultTrend":       "游戏结果(牌路)",
            "report-logTransactionMember":  "玩家额度纪录",
            "currentBet":       "当前投注",
            "onlineMember":     "在线玩家",
            "logOperating":     "操作日志",
            "authority-module": "权限群组管理",
            bulletin:           "公告管理",
            marquee:            "跑马灯管理",
            gameIssue:          "期数管理",
            chat:               "聊天室管理",
            currency:           "币别管理",
            music:              "音乐管理",
            gameMusic:          "音乐游戏管理"
        },
        currency: {
            "0": "",
            "1": "台币",
            "2": "人民币",
            "3": "美元",
            "4": "菲律宾披索",
            "5": "马币",
            "6": "大老爷专用马币",
            "7": "新加坡币"
        }
    }
  }


// WEBPACK FOOTER //
// ./src/lang/zh-cn.js